import React, { useState } from 'react';
import tableStyles from './tableStyles';

interface Column {
  id: string;
  label: string;
}

interface ColumnVisibilityToggleProps {
  columns: Column[];
  hiddenColumns: Set<string>;
  onToggle: (id: string) => void;
}

const ColumnVisibilityToggle: React.FC<ColumnVisibilityToggleProps> = ({ columns, hiddenColumns, onToggle }) => {
  const [open, setOpen] = useState(false);

  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      <button style={tableStyles.toggleBtn} onClick={() => setOpen((v) => !v)}>
        <span>⚙</span> Columns
      </button>
      {open && (
        <>
          {/* backdrop to close on outside click */}
          <div
            style={{ position: 'fixed', inset: 0, zIndex: 99 }}
            onClick={() => setOpen(false)}
          />
          <div style={tableStyles.dropdown}>
            {columns.map((col) => (
              <label key={col.id} style={tableStyles.dropdownLabel}>
                <input
                  type="checkbox"
                  checked={!hiddenColumns.has(col.id)}
                  onChange={() => onToggle(col.id)}
                  style={{ cursor: 'pointer', accentColor: '#6366f1' }}
                />
                {col.label}
              </label>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

export default ColumnVisibilityToggle;
